<template>
  <div
    class="container mx-auto mt-12 md:mt-18 lg:mt-20 xl:mt-24 md:mb-18 mb-12 px-4"
  >
    <div>
      <h2
        class="text-center mx-auto max-w-6xl text-2xl sm:text-3xl lg:text-4xl mb-10"
      >
        {{ dataLocale.data.title }}
      </h2>
      <p
        class="text-lg md:text-xl text-center"
        v-html="dataLocale.data.description"
      ></p>
      <div class="flex flex-wrap justify-center items-center mt-12 gap-4 p-4">
        <div
          class="w-36 xs:w-40 sm:w-48 flex-shrink-0 mb-4"
          v-for="(img, i) in agencies"
          :key="i"
        >
          <nuxt-img
            :src="'/agency/' + img"
            format="webp"
            :width="160"
            loading="lazy"
            :alt="'logo-' + img.replace('.png', '').toLowerCase() + '-company'"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import DataLocale from "~~/config/interface/DataLocale";

const agencies = ref([
  "lbbonline.png",
  "creativecorner.svg",
  "loud.png",
  "Soar Logo.svg",
  "logo-digital-ant.gif",
  "BrainDonors.svg",
  "crackerjack.png",
]);

const dataLocale = new DataLocale([
  {
    locale: "en",
    title: "Worldwide Trust & Collaboration",
    description:
      "Supporting over <span class='font-esbuild font-bold'>1,800</span> agencies and serving more than <span class='font-esbuild font-bold'>30,000</span> enterprises globally with our proven solutions.",
  },
  {
    locale: "fr",
    title: "Confiance et collaboration mondiales",
    description:
      "Soutien à plus de <span class='font-esbuild font-bold'>1 800</span> agences et service à plus de <span class='font-esbuild font-bold'>30 000</span> entreprises dans le monde entier grâce à nos solutions éprouvées.",
  },
  {
    locale: "it",
    title: "Fiducia e collaborazione a livello mondiale",
    description:
      "Supportiamo oltre <span class='font-esbuild font-bold'>1.800</span> agenzie e serviamo più di <span class='font-esbuild font-bold'>30.000</span> aziende a livello globale con le nostre soluzioni comprovate.",
  },
  {
    locale: "de",
    title: "Weltweites Vertrauen und Zusammenarbeit",
    description:
      "Wir unterstützen über <span class='font-esbuild font-bold'>1.800</span> Agenturen und betreuen mehr als <span class='font-esbuild font-bold'>30.000</span> Unternehmen weltweit mit unseren bewährten Lösungen.",
  },
  {
    locale: "es",
    title: "Confianza y colaboración en todo el mundo",
    description:
      "Apoyamos a más de <span class='font-esbuild font-bold'>1.800</span> agencias y prestamos servicio a más de <span class='font-esbuild font-bold'>30.000</span> empresas en todo el mundo con nuestras soluciones probadas.",
  },
  {
    locale: "nl",
    title: "Wereldwijd vertrouwen en samenwerking",
    description:
      "We ondersteunen meer dan <span class='font-esbuild font-bold'>1.800</span> bureaus en bedienen meer dan <span class='font-esbuild font-bold'>30.000</span> ondernemingen wereldwijd met onze bewezen oplossingen.",
  },
  {
    locale: "pt",
    title: "Confiança e Colaboração Mundial",
    description:
      "Apoiando mais de <span class='font-esbuild font-bold'>1.800</span> agências e servindo mais de <span class='font-esbuild font-bold'>30.000</span> empresas globalmente com nossas soluções comprovadas.",
  },
  {
    locale: "ja",
    title: "世界的な信頼とコラボレーション",
    description:
      "実績のあるソリューションにより、世界中で<span class='font-esbuild font-bold'>1,800</span>を超える代理店をサポートし、<span class='font-esbuild font-bold'>30,000</span>を超える企業にサービスを提供しています。",
  },
  {
    locale: "zh",
    title: "全球信任与协作",
    description:
      "通过我们久经考验的解决方案，支持全球超过 <span class='font-esbuild font-bold'>1,800</span> 家机构，并为超过 <span class='font-esbuild font-bold'>30,000</span> 家企业提供服务。",
  },
  {
    locale: "vi",
    title: "Hợp tác & Tin cậy trên Toàn thế giới",
    description:
      "Hỗ trợ hơn <span class='font-esbuild font-bold'>1.800</span> cơ quan và phục vụ hơn <span class='font-esbuild font-bold'>30.000</span> doanh nghiệp trên toàn cầu bằng các giải pháp đã được kiểm chứng của chúng tôi.",
  },
  {
    locale: "id",
    title: "Kepercayaan & Kolaborasi di Seluruh Dunia",
    description:
      "Mendukung lebih dari <span class='font-esbuild font-bold'>1.800</span> agen dan melayani lebih dari <span class='font-esbuild font-bold'>30.000</span> perusahaan secara global dengan solusi kami yang terbukti.",
  },
  {
    locale: "tr",
    title: "Dünya Çapında Güven ve İşbirliği",
    description:
      "Kanıtlanmış çözümlerimizle dünya çapında <span class='font-esbuild font-bold'>1.800</span>'den fazla ajansı destekliyor ve <span class='font-esbuild font-bold'>30.000</span>'den fazla kuruluşa hizmet veriyoruz.",
  },
  {
    locale: "hi",
    title: "विश्वव्यापी विश्वास और सहयोग",
    description:
      "हमारे सिद्ध समाधानों के साथ विश्व स्तर पर <span class='font-esbuild font-bold'>1,800</span> से अधिक एजेंसियों का समर्थन करना और <span class='font-esbuild font-bold'>30,000</span> से अधिक उद्यमों की सेवा करना।",
  },
  {
    locale: "th",
    title: "ความไว้วางใจและความร่วมมือทั่วโลก",
    description:
      "สนับสนุนหน่วยงานกว่า <span class='font-esbuild font-bold'>1,800</span> แห่ง และให้บริการแก่วิสาหกิจกว่า <span class='font-esbuild font-bold'>30,000</span> แห่งทั่วโลกด้วยโซลูชันที่ได้รับการพิสูจน์แล้วของเรา",
  },
]);
</script>
